import { createSystem, defaultConfig, defineConfig } from '@chakra-ui/react';
import { insetShellGlobalCss, libraryConfig } from '@ionq/legacy-ui';

// The remote's theme additions (data-only SystemConfig). Same top-level-await
// contract as router.tsx's 'remote/routes' import: the shell already
// hard-depends on the remote at boot, so an unreachable remote fails here the
// same way it fails there.
const remoteThemeConfig = (await import('remote/theme-config')).default;

const appConfig = defineConfig({
    // The inset shell's document-scroll globals (rationale in legacy-ui's
    // inset-shell.tsx, next to the shell components).
    globalCss: insetShellGlobalCss,
});

// Remote config first after defaults so shell identity (libraryConfig /
// appConfig) wins any accidental overlap; the remote's keys are contractually
// additive-only (apps/console/README.md).
export const system = createSystem(
    defaultConfig,
    remoteThemeConfig,
    libraryConfig,
    appConfig,
);
